export const es: Record<string, string> = {
  'Add': 'Añadir',
  'Add user to favorites': 'Añadir usuario a favoritos',
  'All time': 'Todo el período',
  'Around the point you selected': 'Alrededor del punto seleccionado',
  'Around the visible map area': 'En el área visible del mapa',
  'Back to map': 'Volver al mapa',
  'Back to sign in': 'Volver al inicio de sesión',
  'Cancel manual location placement': 'Cancelar la ubicación manual',
  'Community map': 'Mapa de la comunidad',
  'Connecting to your device’s location signal…': 'Conectando con la ubicación de tu dispositivo…',
  'Could not get your current location.': 'No se pudo obtener tu ubicación actual.',
  'Could not save this location. Please try again.': 'No se pudo guardar esta ubicación. Inténtalo de nuevo.',
  'Create account': 'Crear cuenta',
  'Creating account…': 'Creando cuenta…',
  'Dark Mode': 'Modo oscuro',
  'Enable location': 'Activar ubicación',
  'End': 'Fin',
  'Failed to get location': 'No se pudo obtener la ubicación',
  'Failed to load application statistics.': 'No se pudieron cargar las estadísticas de la aplicación.',
  'Failed to load map activity.': 'No se pudo cargar la actividad del mapa.',
  'Failed to load statuses': 'No se pudieron cargar los estados',
  'Favorite person': 'Persona favorita',
  'Favorite user': 'Usuario favorito',
  'Find a person in direct messages': 'Buscar una persona en mensajes directos',
  'Find a person…': 'Buscar una persona…',
  'Getting location…': 'Obteniendo ubicación…',
  'Hide password': 'Ocultar contraseña',
  'Hide statuses': 'Ocultar estados',
  'Home': 'Inicio',
  'Join the map': 'Únete al mapa',
  'Last day': 'Último día',
  'Last month': 'Último mes',
  'Last week': 'Última semana',
  'Light Mode': 'Modo claro',
  'Like': 'Me gusta',
  'Liked': 'Te gusta',
  'Live location sharing is active.': 'La ubicación en vivo está activa.',
  'Load older messages': 'Cargar mensajes anteriores',
  'Loading older messages…': 'Cargando mensajes anteriores…',
  'Manual location is active.': 'La ubicación manual está activa.',
  'Map friend': 'Amigo del mapa',
  'My statuses': 'Mis estados',
  'Nearby person': 'Persona cercana',
  'Nearby statuses': 'Estados cercanos',
  'New people': 'Personas nuevas',
  'No nearby stories in this area yet': 'Aún no hay historias cercanas en esta área',
  'No statuses found': 'No se encontraron estados',
  'No stories shared yet': 'Aún no hay historias compartidas',
  'People and statuses could not be refreshed. Your current map view is still available.': 'No se pudieron actualizar las personas y los estados. La vista actual del mapa sigue disponible.',
  'Place a manual location': 'Indicar una ubicación manual',
  'Profile': 'Perfil',
  'Reconnecting people and nearby stories…': 'Reconectando personas e historias cercanas…',
  'Refresh map': 'Actualizar mapa',
  'Remove': 'Eliminar',
  'Remove user from favorites': 'Eliminar usuario de favoritos',
  'Reply': 'Responder',
  'Save': 'Guardar',
  'Saved': 'Guardado',
  'Saving…': 'Guardando…',
  'Search all direct messages': 'Buscar en todos los mensajes directos',
  'Search all messages…': 'Buscar en todos los mensajes…',
  'Search failed': 'La búsqueda falló',
  'Searching…': 'Buscando…',
  'Selected avatar': 'Avatar seleccionado',
  'Sending…': 'Enviando…',
  'Set a manual location': 'Indicar una ubicación manual',
  'Set here': 'Fijar aquí',
  'Set my location here': 'Fijar mi ubicación aquí',
  'Set your map location to make this status discoverable nearby.': 'Indica tu ubicación en el mapa para que este estado pueda descubrirse cerca.',
  'Setting your location…': 'Estableciendo tu ubicación…',
  'Share Status': 'Compartir estado',
  'Shared from the map': 'Compartido desde el mapa',
  'Sharing…': 'Compartiendo…',
  'Show password': 'Mostrar contraseña',
  'Show status location on map': 'Mostrar la ubicación del estado en el mapa',
  'Signing in…': 'Iniciando sesión…',
  'Someone': 'Alguien',
  'Start a conversation': 'Iniciar una conversación',
  'Status details': 'Detalles del estado',
  'That status is no longer available.': 'Ese estado ya no está disponible.',
  'The map is not ready yet.': 'El mapa aún no está listo.',
  'The point you selected on the map will be attached to this status.': 'El punto que seleccionaste en el mapa se adjuntará a este estado.',
  "This user hasn't posted any statuses yet": 'Este usuario aún no ha publicado estados',
  'Time span': 'Intervalo de tiempo',
  'Unable to get your location': 'No se pudo obtener tu ubicación',
  'Unfavorite user': 'Quitar usuario de favoritos',
  'Unknown User': 'Usuario desconocido',
  'Unlike': 'Ya no me gusta',
  'User details': 'Detalles del usuario',
  'User information not available': 'La información del usuario no está disponible',
  'View statuses': 'Ver estados',
  'Waiting for a precise device location…': 'Esperando una ubicación precisa del dispositivo…',
  'What should nearby people know?': '¿Qué deberían saber las personas cercanas?',
  'What’s happening around you?': '¿Qué está pasando a tu alrededor?',
  'What’s happening, and when?': '¿Qué está pasando y cuándo?',
  'What’s the vibe, and where?': '¿Cuál es el ambiente y dónde?',
  'You': 'Tú',
  'Your current map location will be attached so nearby people can discover it.': 'Tu ubicación actual en el mapa se adjuntará para que las personas cercanas puedan encontrar tu estado.',
  'Your location': 'Tu ubicación',
  'Your map location': 'Tu ubicación en el mapa',
  'Close about mapbl': 'Cerrar información sobre mapbl',
  'Close cluster details': 'Cerrar detalles del grupo',
  'Close create status dialog': 'Cerrar creación de estado',
  'Close details': 'Cerrar detalles',
  'Close direct messages': 'Cerrar mensajes directos',
  'Close favorites': 'Cerrar favoritos',
  'Close map actions': 'Cerrar acciones del mapa',
  'Close map details': 'Cerrar detalles del mapa',
  'Close menu': 'Cerrar menú',
  'Close notifications': 'Cerrar notificaciones',
  'Close panel': 'Cerrar panel',
  'Close search': 'Cerrar búsqueda',
  'Close statistics': 'Cerrar estadísticas',
  'Close status': 'Cerrar estado',
  'Close statuses dialog': 'Cerrar lista de estados',
  'Close user profile': 'Cerrar perfil del usuario',
  'Close user settings': 'Cerrar ajustes del usuario',
  'Dismiss about mapbl': 'Ocultar información sobre mapbl',
  'Dismiss create status dialog': 'Ocultar creación de estado',
  'Dismiss error': 'Ocultar error',
  'Dismiss map pulse': 'Ocultar pulso del mapa',
  'Dismiss my statuses': 'Ocultar mis estados',
  'Dismiss nearby statuses': 'Ocultar estados cercanos',
  'Dismiss profile settings': 'Ocultar ajustes del perfil',
  'Dismiss status error': 'Ocultar error del estado',
  'Dismiss welcome message': 'Ocultar bienvenida',
  'Opening your map…': 'Abriendo tu mapa…',
  'Checking your map identity…': 'Comprobando tu identidad en el mapa…',
  'Actions for this map point': 'Acciones para este punto del mapa',
  'Avatar crop zoom': 'Zoom de recorte del avatar',
  'Avatar image URL': 'URL de la imagen del avatar',
  'Changes to this policy': 'Cambios en esta política',
  'Effective September 7, 2026': 'Vigente desde el 7 de septiembre de 2026',
  'Enter your display name': 'Introduce tu nombre visible',
  'Frame your avatar': 'Encuadra tu avatar',
  'From': 'Desde',
  'Here · 50 m': 'Aquí · 50 m',
  'How information is used': 'Cómo se utiliza la información',
  'How people will see you': 'Cómo te verán los demás',
  'Information used by the game': 'Información utilizada por el juego',
  'JPEG, PNG, or GIF up to 5 MB.': 'JPEG, PNG o GIF de hasta 5 MB.',
  'Map content is not verified. Treat every status, identity, and location as fictional game content—not fact.': 'El contenido del mapa no está verificado. Considera cada estado, identidad y ubicación como contenido ficticio del juego, no como un hecho.',
  'Maps and service providers': 'Mapas y proveedores de servicios',
  'Move the map until the target is over the right place.': 'Mueve el mapa hasta que el marcador esté sobre el lugar correcto.',
  'OpenStreetMap copyright and attribution': 'Derechos de autor y atribución de OpenStreetMap',
  'mapbl is a fantasy experience for fun.': 'mapbl es una experiencia de fantasía para divertirse.',
  'mapbl version': 'Versión de mapbl',
  'mapbl is a playful social map where you can share what is happening, discover nearby statuses, and see the community come alive around you.': 'mapbl es un mapa social y divertido donde puedes compartir lo que ocurre, descubrir estados cercanos y ver cómo cobra vida la comunidad.',
  'mapbl is a game and creative social experience. Names, profiles, locations, statuses, events, announcements, and other content shown on the map are user-submitted, are not independently verified, and must not be treated as statements of fact. Everything you see should be understood as fictional, role-play, or fantasy content created for entertainment only.': 'mapbl es un juego y una experiencia social creativa. Los nombres, perfiles, ubicaciones, estados, eventos, anuncios y demás contenido del mapa proceden de usuarios, no se verifican de forma independiente y no deben considerarse hechos. Todo lo que ves debe entenderse como contenido ficticio, de rol o fantasía creado solo con fines de entretenimiento.',
  'We process only the information needed to provide the experience: account details you submit, such as your email, display name, bio, avatar, and password in protected hashed form; statuses and reactions you create; a browser-selected or manually selected map location; and sign-in tokens stored on your device. This information is saved only so the game can operate and remember your account and game activity.': 'Procesamos únicamente la información necesaria para ofrecer la experiencia: los datos de cuenta que proporcionas, como correo, nombre visible, biografía, avatar y contraseña protegida mediante hash; los estados y reacciones que creas; una ubicación seleccionada por el navegador o manualmente; y los tokens de inicio de sesión guardados en tu dispositivo. Esta información se almacena solo para que el juego funcione y recuerde tu cuenta y actividad.',
  'Submitted information is used only to authenticate you, display and personalize the map, show game content, support nearby discovery, and maintain the service. mapbl does not sell your personal information or use your game activity to make real-world claims about you.': 'La información enviada se utiliza únicamente para autenticarte, mostrar y personalizar el mapa, presentar contenido del juego, facilitar el descubrimiento cercano y mantener el servicio. mapbl no vende tu información personal ni utiliza tu actividad para hacer afirmaciones sobre ti en el mundo real.',
  'The experience is built around a shared map. Your chosen game identity, avatar, bio, approximate or selected location, statuses, and reactions may be visible to other players. Your password and authentication tokens are not displayed to other players. Do not use real-world secrets, sensitive personal details, or a precise real-world location in your public game content.': 'La experiencia gira en torno a un mapa compartido. La identidad de juego, el avatar, la biografía, la ubicación aproximada o seleccionada, los estados y las reacciones pueden ser visibles para otros jugadores. Tu contraseña y tokens de autenticación no se muestran. No incluyas secretos reales, datos personales sensibles ni una ubicación real precisa en el contenido público del juego.',
  'The site may rely on hosting, map, and geocoding providers to deliver the service. Those providers may receive ordinary technical requests, such as an IP address and map coordinates, under their own privacy terms. We limit access to stored information to what is necessary to operate and protect the game.': 'El sitio puede depender de proveedores de alojamiento, mapas y geocodificación. Estos proveedores pueden recibir solicitudes técnicas habituales, como una dirección IP y coordenadas, conforme a sus propias condiciones de privacidad. Limitamos el acceso a la información almacenada a lo necesario para operar y proteger el juego.',
  'You choose what identity, status, and location to submit. You can update your profile and game content through the available controls, stop sharing a browser location by changing your browser permissions, and sign out to remove sign-in tokens from the device. Please contact the site operator if you need help with your account or stored information.': 'Tú eliges qué identidad, estado y ubicación enviar. Puedes actualizar tu perfil y contenido con los controles disponibles, dejar de compartir la ubicación cambiando los permisos del navegador y cerrar sesión para eliminar los tokens del dispositivo. Contacta con el operador del sitio si necesitas ayuda con tu cuenta o información almacenada.',
  'We may update this policy as the game changes. The effective date at the top will be revised when that happens. Continued use of mapbl after an update means you accept the revised policy.': 'Podemos actualizar esta política cuando cambie el juego. En ese caso se modificará la fecha de vigencia indicada arriba. Seguir usando mapbl después de una actualización implica aceptar la política revisada.',
  'About': 'Acerca de',
  'About mapbl': 'Acerca de mapbl',
  'About the service': 'Acerca del servicio',
  'Account': 'Cuenta',
  'All stories': 'Todas las historias',
  'Application statistics': 'Estadísticas de la aplicación',
  'Area': 'Área',
  'Back to conversations': 'Volver a las conversaciones',
  'Bio': 'Biografía',
  'Cancel': 'Cancelar',
  'Choose your map position': 'Elige tu posición en el mapa',
  'Choose your map vibe': 'Elige tu estilo en el mapa',
  'Clear': 'Borrar',
  'Community first': 'La comunidad primero',
  'Connection interrupted': 'Conexión interrumpida',
  'Could not locate you': 'No pudimos localizarte',
  'Create Status': 'Crear estado',
  'Create an account': 'Crear una cuenta',
  'Create status': 'Crear estado',
  'Create your identity': 'Crea tu identidad',
  'Crop Current Avatar': 'Recortar avatar actual',
  'Direct Messages': 'Mensajes directos',
  'Direct messages': 'Mensajes directos',
  'Display Name': 'Nombre visible',
  'Display name': 'Nombre visible',
  'Edit': 'Editar',
  'Edit direct message': 'Editar mensaje directo',
  'Edit reply': 'Editar respuesta',
  'Edited': 'Editado',
  'Email address': 'Correo electrónico',
  'Emoji collections': 'Colecciones de emojis',
  'Favorite people or statuses to keep them close.': 'Guarda personas o estados en favoritos para tenerlos cerca.',
  'Favorites': 'Favoritos',
  'Filter by status type': 'Filtrar por tipo de estado',
  'Filter profile statuses': 'Filtrar estados del perfil',
  'Filter the signal': 'Filtrar la señal',
  'Finding your location': 'Buscando tu ubicación',
  'Go to my location': 'Ir a mi ubicación',
  'Ignore user': 'Ignorar usuario',
  'Ignored users': 'Usuarios ignorados',
  'Jump to latest messages': 'Ir a los mensajes más recientes',
  'Last 24 hours': 'Últimas 24 horas',
  'Last hour': 'Última hora',
  'Link (optional)': 'Enlace (opcional)',
  'Live community signal': 'Actividad de la comunidad en vivo',
  'Live map stories': 'Historias en vivo del mapa',
  'Load more results': 'Cargar más resultados',
  'Load older': 'Cargar anteriores',
  'Load older replies': 'Cargar respuestas anteriores',
  'Loading favorites…': 'Cargando favoritos…',
  'Loading ignored users…': 'Cargando usuarios ignorados…',
  'Loading messages…': 'Cargando mensajes…',
  'Loading replies…': 'Cargando respuestas…',
  'Loading statuses': 'Cargando estados',
  'Loading user data...': 'Cargando datos del usuario…',
  'Loading…': 'Cargando…',
  'Locating you': 'Localizándote',
  'Location needs attention': 'La ubicación necesita atención',
  'Make it yours': 'Hazlo tuyo',
  'Map': 'Mapa',
  'Map avatar preview': 'Vista previa del avatar',
  'Map discovery': 'Descubrir en el mapa',
  'Map navigation': 'Navegación del mapa',
  'Map pulse': 'Pulso del mapa',
  'Map refresh paused': 'Actualización del mapa en pausa',
  'Mark all read': 'Marcar todo como leído',
  'Message': 'Mensaje',
  'Message *': 'Mensaje *',
  'Messages': 'Mensajes',
  'My Location': 'Mi ubicación',
  'My Statuses': 'Mis estados',
  'Nearby Statuses': 'Estados cercanos',
  'Nearby activity': 'Actividad cercana',
  'Nearby radius': 'Radio cercano',
  'New status': 'Nuevo estado',
  'No matching messages found.': 'No se encontraron mensajes coincidentes.',
  'No notifications yet': 'Aún no hay notificaciones',
  'No people found in your direct messages.': 'No se encontraron personas en tus mensajes directos.',
  'Nothing shared in this cluster yet': 'Aún no se compartió nada en este grupo',
  'Notifications': 'Notificaciones',
  'Notification settings': 'Ajustes de notificaciones',
  'Number of statuses': 'Número de estados',
  'Observe nearby statuses': 'Observa estados cercanos',
  'Open shared link': 'Abrir enlace compartido',
  'Password': 'Contraseña',
  'People': 'Personas',
  'People and statuses you saved': 'Personas y estados guardados',
  'People make the map': 'Las personas crean el mapa',
  'Post a new status or message here': 'Publica aquí un nuevo estado o mensaje',
  'Posted': 'Publicado',
  'Privacy & play': 'Privacidad y juego',
  'Privacy Policy': 'Política de privacidad',
  'Private conversation': 'Conversación privada',
  'Private conversations': 'Conversaciones privadas',
  'Profile settings': 'Ajustes del perfil',
  'Reading the map pulse…': 'Leyendo el pulso del mapa…',
  'Ready to upload': 'Listo para subir',
  'Recent': 'Recientes',
  'Recent searches': 'Búsquedas recientes',
  'Refresh': 'Actualizar',
  'Refresh statuses': 'Actualizar estados',
  'Refreshing the map': 'Actualizando el mapa',
  'Reload mapbl': 'Recargar mapbl',
  'Replies and direct messages': 'Respuestas y mensajes directos',
  'Reply to status': 'Responder al estado',
  'Say hello to start the conversation.': 'Saluda para iniciar la conversación.',
  'Search a wider area': 'Buscar en un área más amplia',
  'Search every message in your direct conversations.': 'Busca en todos los mensajes de tus conversaciones directas.',
  'Select a conversation to read your messages.': 'Selecciona una conversación para leer tus mensajes.',
  'Selected map point': 'Punto seleccionado del mapa',
  'Selected period': 'Período seleccionado',
  'Send direct message': 'Enviar mensaje directo',
  'Settings': 'Ajustes',
  'Share nearby': 'Compartir cerca',
  'Short bio': 'Biografía breve',
  'Show': 'Mostrar',
  'Sign in': 'Iniciar sesión',
  'Sign in to mapbl': 'Inicia sesión en mapbl',
  'Start must be before end.': 'El inicio debe ser anterior al fin.',
  'Status reply': 'Respuesta al estado',
  'Statuses': 'Estados',
  'Stop ignoring': 'Dejar de ignorar',
  'Surprise me': 'Sorpréndeme',
  'Surprise me with an emoji': 'Sorpréndeme con un emoji',
  'The map hit a rough patch': 'El mapa encontró un problema',
  'Time': 'Tiempo',
  'Time filter': 'Filtro de tiempo',
  'Time span end': 'Fin del intervalo de tiempo',
  'Time span start': 'Inicio del intervalo de tiempo',
  'To': 'Hasta',
  'Toggle menu': 'Abrir o cerrar menú',
  'Try again': 'Intentar de nuevo',
  'Unread': 'No leído',
  'Updated': 'Actualizado',
  'Use a photo': 'Usar una foto',
  'Use an image URL instead': 'Usar una URL de imagen',
  'Use emoji': 'Usar emoji',
  'Use this crop': 'Usar este recorte',
  'What are you sharing?': '¿Qué estás compartiendo?',
  'Width': 'Ancho',
  'Write a direct message': 'Escribir un mensaje directo',
  'Write a message…': 'Escribe un mensaje…',
  'Write a reply…': 'Escribe una respuesta…',
  'You are not ignoring anyone.': 'No estás ignorando a nadie.',
  'Your map identity': 'Tu identidad en el mapa',
  'Your password': 'Tu contraseña',
  'Your recent posts and moments': 'Tus publicaciones y momentos recientes',
  'You’re on the map': 'Estás en el mapa',
  'Zoom': 'Zoom',
  'edited': 'editado',
  'latest': 'más recientes',
  'optional': 'opcional',
  'or set it manually on the map': 'o indícala manualmente en el mapa',
  'statuses': 'estados',
  'sent you a message': 'te envió un mensaje',
  'replied to your status': 'respondió a tu estado',
  'Just now': 'Ahora mismo',
  'Statuses (': 'Estados (',
  'Users (': 'Usuarios (',
  'people ·': 'personas ·',
  'Failed to update profile': 'No se pudo actualizar el perfil',
  'Failed to upload avatar': 'No se pudo subir el avatar',
  'Failed to log out': 'No se pudo cerrar sesión',
  'Please select a valid image file (JPEG, PNG, GIF)': 'Selecciona un archivo de imagen válido (JPEG, PNG o GIF)',
  'File size must be less than 5MB': 'El archivo debe ocupar menos de 5 MB',
  'Failed to load current avatar image for cropping': 'No se pudo cargar el avatar actual para recortarlo',
  'Geolocation is not supported by this browser': 'Este navegador no admite geolocalización',
  'Geolocation is not supported by this browser.': 'Este navegador no admite geolocalización.',
  'Location permission denied': 'Permiso de ubicación denegado',
  'Location permission denied. Please enable location access in your browser settings.': 'Permiso de ubicación denegado. Activa el acceso en los ajustes del navegador.',
  'Location request timed out. Please try again.': 'Se agotó el tiempo para obtener la ubicación. Inténtalo de nuevo.',
  'Location tracking failed': 'Falló el seguimiento de ubicación',
  'Location tracking timed out': 'Se agotó el tiempo del seguimiento de ubicación',
  'Location unavailable': 'Ubicación no disponible',
  'Location unavailable. Please check your GPS or network connection.': 'Ubicación no disponible. Comprueba el GPS o la conexión de red.',
  'A fantasy map made for fun': 'Un mapa de fantasía hecho para divertirse',
  'A little about you': 'Un poco sobre ti',
  'A quick look at how the community is moving.': 'Un vistazo rápido a la actividad de la comunidad.',
  'Bright, friendly, and a little futuristic.': 'Brillante, amigable y un poco futurista.',
  'Choose a photo or an upbeat emoji. This is how people recognize you on the map.': 'Elige una foto o un emoji alegre. Así te reconocerán en el mapa.',
  'Choose how long new live locations and statuses animate on the map.': 'Elige durante cuánto tiempo se animan las nuevas ubicaciones y estados en vivo en el mapa.',
  'Choose someone on the map to start a conversation.': 'Elige a alguien en el mapa para iniciar una conversación.',
  'Drag to position, then fine-tune the zoom.': 'Arrastra para posicionar y ajusta el zoom.',
  'Find the bright moments happening around you.': 'Descubre los mejores momentos que ocurren a tu alrededor.',
  'Share a location, leave a status, and discover the people and energy nearby.': 'Comparte una ubicación, publica un estado y descubre personas y actividad cerca.',
  'Sign out of mapbl on this device.': 'Cerrar sesión de mapbl en este dispositivo.',
  'Tell us about yourself': 'Cuéntanos sobre ti',
  'Their locations, statuses, and direct messages are hidden both ways.': 'Sus ubicaciones, estados y mensajes directos se ocultan en ambos sentidos.',
  'What other players can see': 'Qué pueden ver otros jugadores',
  'Your choices': 'Tus opciones',
  '5 seconds': '5 segundos',
  '10 seconds': '10 segundos',
  'A quick heads-up': 'Un aviso rápido',
  'Recommended': 'Recomendado',
  'Never': 'Nunca',
  'Keep markers still': 'Mantener quietos los marcadores',
  'Until I open it': 'Hasta que lo abra',
  'Animate until selected': 'Animar hasta seleccionarlo',
  'Uploading…': 'Subiendo…',
  'Upload avatar': 'Subir avatar',
  'Logging out…': 'Cerrando sesión…',
  'Logout': 'Cerrar sesión',
  'Updating…': 'Actualizando…',
  'Update Profile': 'Actualizar perfil',
  'Language': 'Idioma',
  'Interface language': 'Idioma de la interfaz',
  'English': 'Inglés',
  'Ukrainian': 'Ucraniano',
  'Spanish': 'Español',
  'French': 'Francés',
  'Norwegian': 'Noruego',
  'Dutch': 'Neerlandés',
  'Romanian': 'Rumano',
  'Profile updated successfully!': '¡Perfil actualizado correctamente!',
  'Avatar uploaded successfully!': '¡Avatar subido correctamente!',
  'Welcome back': 'Te damos la bienvenida',
  'Your map, people, and nearby moments are waiting.': 'Tu mapa, las personas y los momentos cercanos te esperan.',
  'New to mapbl?': '¿Eres nuevo en mapbl?',
  'Already on mapbl?': '¿Ya estás en mapbl?',
  'Password is required': 'La contraseña es obligatoria',
  'Email is required': 'El correo es obligatorio',
  'Enter a valid email address': 'Introduce un correo electrónico válido',
  'At least 6 characters': 'Al menos 6 caracteres',
  'Your account and map data are safe. Reload mapbl to reconnect and pick up where you left off.': 'Tu cuenta y los datos del mapa están seguros. Recarga mapbl para volver a conectarte y continuar.',
};
